module.exports = __webpack_public_path__ + "img/menu_btn.fe323b4b.png";